import { ModalProps } from 'antd';
import { PrintLabworkModalProps } from 'modules/donor/components/PrintLabworkModal';
import { LabworkAttachmentsModalPropTypes } from 'modules/donor/types';
import { useState } from 'react';

import { ContextType } from './type';

export const useProviderValue = (): ContextType => {
  const [modalProps, setModalProps] = useState<
    ModalProps & LabworkAttachmentsModalPropTypes
  >();
  const [visible, setVisible] = useState(false);

  const showModal = (params?: PrintLabworkModalProps) => {
    params && setModalProps({ ...modalProps, ...params });
    setVisible(true);
  };

  const updateModalProps = (props: ModalProps) => {
    setModalProps(props);
  };

  const hideModal = () => {
    setVisible(false);
  };

  return {
    modalConfig: {
      ...modalProps,
      visible,
      hide: hideModal,
    },
    showModal,
    hideModal,
    updateModalProps,
  };
};
